// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #faf8ef;
  color: #776e65;
  font-size: 18px;
  line-height: 28px;
}
h1 {
  font-size: 36px;
  line-height: 46px;
}
a {
  color: #776e65;
}
a:hover {
  text-decoration: none;
}
.tile {
  position: absolute;
  width: 84px;
  height: 84px;
  margin: 8px;
  border-radius: 4px;
  background-color: #eee4da;
  color: #776e65;
  font-weight: bold;
  text-align: center;
  font-size: 48px;
  line-height: 1.617;
  transition-property: left, top, transform;
  transition-duration: 250ms, 250ms, 100ms;
  transform: scale(1);
  /* -=-=-=- START OF TEXT SIZE -=-=-=- */
  /* -=-=-=-= END OF TEXT SIZE =-=-=-=- */
}
.tile-128,
.tile-256,
.tile-512 {
  font-size: 44px;
  line-height: 1.7556;
}
.tile-1024,
.tile-2048 {
  font-size: 32px;
  line-height: 2.4486;
}
.tile-2 {
  background: #eee4da;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0), inset 0 0 0 1px rgba(255, 255, 255, 0);
}
.tile-4 {
  background: #ede0c8;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0), inset 0 0 0 1px rgba(255, 255, 255, 0);
}
.tile-8 {
  color: #f9f6f2;
  background: #f2b179;
}
.tile-16 {
  color: #f9f6f2;
  background: #f59563;
}
.tile-32 {
  color: #f9f6f2;
  background: #f67c5f;
}
.tile-64 {
  color: #f9f6f2;
  background: #f65e3b;
}
.tile-128 {
  color: #f9f6f2;
  background: #edcf72;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.2381), inset 0 0 0 1px rgba(255, 255, 255, 0.14286);
}
.tile-256 {
  color: #f9f6f2;
  background: #edcc61;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.31746), inset 0 0 0 1px rgba(255, 255, 255, 0.19048);
}
.tile-512 {
  color: #f9f6f2;
  background: #edc850;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.39683), inset 0 0 0 1px rgba(255, 255, 255, 0.2381);
}
.tile-1024 {
  color: #f9f6f2;
  background: #edc53f;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.47619), inset 0 0 0 1px rgba(255, 255, 255, 0.28571);
}
.tile-2048 {
  color: #f9f6f2;
  background: #edc22e;
  box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.55556), inset 0 0 0 1px rgba(255, 255, 255, 0.33333);
}
`, "",{"version":3,"sources":["webpack://./src/styles/core.less","webpack://./src/components/Tile/tile.less"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;ACHF;ADMA;EACE,eAAA;EACA,iBAAA;ACJF;ADOA;EACE,cAAA;ACLF;ADOE;EACE,qBAAA;ACLJ;AAjBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;EACA,wCAAA;EACA,mBAAA;EAmBA,uCAAuC;EACvC,uCAAuC;AACzC;AAlBE;;;EAGE,eAAA;EACA,mBAAA;AAoBJ;AAjBE;;EAEE,eAAA;EACA,mBAAA;AAmBJ;AAfE;EACE,mBAAA;EACA,wFAAA;AAiBJ;AAbE;EACE,mBAAA;EACA,wFAAA;AAeJ;AAXE;EACE,cAAA;EACA,mBAAA;AAaJ;AAVE;EACE,cAAA;EACA,mBAAA;AAYJ;AATE;EACE,cAAA;EACA,mBAAA;AAWJ;AARE;EACE,cAAA;EACA,mBAAA;AAUJ;AAPE;EACE,cAAA;EACA,mBAAA;EACA,mGAAA;AASJ;AALE;EACE,cAAA;EACA,mBAAA;EACA,oGAAA;AAOJ;AAHE;EACE,cAAA;EACA,mBAAA;EACA,mGAAA;AAKJ;AADE;EACE,cAAA;EACA,mBAAA;EACA,oGAAA;AAGJ;AACE;EACE,cAAA;EACA,mBAAA;EACA,oGAAA;AACJ","sourcesContent":["@import \"variables.less\";\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: #faf8ef;\n  color: #776e65;\n  font-size: @pixel-size * 2.25;\n  line-height: @pixel-size * 3.5;\n}\n\nh1 {\n  font-size: 4.5 * @pixel-size;\n  line-height: 5.75 * @pixel-size;\n}\n\na {\n  color: #776e65;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n","@import \"../../styles/index.less\";\n\n.tile {\n  position: absolute;\n  width: @pixel-size * 10.5;\n  height: @pixel-size * 10.5;\n  margin: @pixel-size * 1;\n  border-radius: @pixel-size * 0.5;\n  background-color: #eee4da;\n  color: #776e65;\n  font-weight: bold;\n  text-align: center;\n  font-size: @pixel-size * 6;\n  line-height: 2.1 * 0.77;\n  transition-property: left, top, transform;\n  transition-duration: 250ms, 250ms, 100ms;\n  transform: scale(1);\n\n  /* -=-=-=- START OF TEXT SIZE -=-=-=- */\n  &-128,\n  &-256,\n  &-512 {\n    font-size: @pixel-size * 5.5;\n    line-height: 2.28 * 0.77;\n  }\n\n  &-1024,\n  &-2048 {\n    font-size: @pixel-size * 4;\n    line-height: 3.18 * 0.77;\n  }\n  /* -=-=-=-= END OF TEXT SIZE =-=-=-=- */\n\n  &-2 {\n    background: #eee4da;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0),\n      inset 0 0 0 1px rgba(255, 255, 255, 0);\n  }\n\n  &-4 {\n    background: #ede0c8;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0),\n      inset 0 0 0 1px rgba(255, 255, 255, 0);\n  }\n\n  &-8 {\n    color: #f9f6f2;\n    background: #f2b179;\n  }\n\n  &-16 {\n    color: #f9f6f2;\n    background: #f59563;\n  }\n\n  &-32 {\n    color: #f9f6f2;\n    background: #f67c5f;\n  }\n\n  &-64 {\n    color: #f9f6f2;\n    background: #f65e3b;\n  }\n\n  &-128 {\n    color: #f9f6f2;\n    background: #edcf72;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.2381),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.14286);\n  }\n\n  &-256 {\n    color: #f9f6f2;\n    background: #edcc61;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.31746),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.19048);\n  }\n\n  &-512 {\n    color: #f9f6f2;\n    background: #edc850;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.39683),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.2381);\n  }\n\n  &-1024 {\n    color: #f9f6f2;\n    background: #edc53f;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.47619),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.28571);\n  }\n\n  &-2048 {\n    color: #f9f6f2;\n    background: #edc22e;\n    box-shadow: 0 0 30px 10px rgba(243, 215, 116, 0.55556),\n      inset 0 0 0 1px rgba(255, 255, 255, 0.33333);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
